import { render } from "./Item_Categories.vue?vue&type=template&id=d8f80436"
import script from "./Item_Categories.vue?vue&type=script&lang=js"
export * from "./Item_Categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__